/* eslint-disable */
export function testClassDeco(constructor: Function) {
  console.log(constructor);
  console.log(constructor.prototype);
}

export function uuid() {
  const s: Array<any> = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';
  const uuid = s.join('');
  return uuid;
}

export function randomString(length: number) {
  var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; --i) {
    result += str[Math.floor(Math.random() * str.length)];
  }
  return result;
}

/**
 * 中划线字符驼峰
 * @param {*} str 要转换的字符串
 * @returns 返回值
 */
export function toHump(str: string) {
  if (!str) return str;
  return str
    .replace(/\-(\w)/g, function (all, letter) {
      return letter.toUpperCase();
    })
    .replace(/(\s|^)[a-z]/g, function (char) {
      return char.toUpperCase();
    });
}

export function currentDate() {
  const d = new Date();
  let str = '';
  str += d.getFullYear() + '-'; // 获取当前年份
  const month = d.getMonth() + 1;
  str += month < 10 ? '0' + month + '-' : month + '-'; // 获取当前月份（0——11）
  str += d.getDate() + ' ';
  const hours = d.getHours();
  str += hours < 10 ? '0' + hours : hours + ':';
  str += d.getMinutes() + ':';
  str += d.getSeconds();
  return str;
}

export function toTimestamp(value: any) {
  const date = new Date(value);
  if (date instanceof Date && !isNaN(date.valueOf())) {
    return date.getTime();
  }
  return null;
}

export function toTimes(value: any) {
  var getTime = value; //获取到当前时间戳
  var time = new Date(getTime); //创建一个日期对象
  var year = time.getFullYear(); // 年
  var month = (time.getMonth() + 1).toString().padStart(2, '0'); // 月
  var date = time.getDate().toString().padStart(2, '0'); // 日
  var hour = time.getHours().toString().padStart(2, '0'); // 时
  var minute = time.getMinutes().toString().padStart(2, '0'); // 分
  var second = time.getSeconds().toString().padStart(2, '0'); // 秒
  return (
    year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
  );
}

//直播话术切割块元素
export function splitScriptText(text: string) {
  const result = [];
  let currentIndex = 0;
  let id = 1;
  // 先匹配所有 *...* （最高优先级）
  const starRegex = / \*.*?\* /g;
  const starMatches = [];
  let starMatch;
  while ((starMatch = starRegex.exec(text)) !== null) {
    starMatches.push({
      start: starMatch.index,
      end: starMatch.index + starMatch[0].length,
      text: starMatch[0],
      type: 3,
    });
  }

  // 按起始位置排序
  starMatches.sort((a, b) => a.start - b.start);

  // 处理文本
  let lastIndex = 0;

  for (const starMatch of starMatches) {
    // 添加 *...* 之前的内容
    if (starMatch.start > lastIndex) {
      const beforeText = text.slice(lastIndex, starMatch.start);
      processNonStarText(beforeText, result, () => id++);
    }

    // 添加 *...* 本身
    result.push({
      id,
      text: starMatch.text,
      type: 3,
    });
    id++;

    lastIndex = starMatch.end;
  }

  // 处理剩余文本
  if (lastIndex < text.length) {
    const remainingText = text.slice(lastIndex);
    processNonStarText(remainingText, result, () => id++);
  }

  return result;
}

// 处理不包含 *...* 的文本
function processNonStarText(text: string, result: any[], getId: () => number) {
  const regex = /(#.*?【.*?】.*?#|【.*?】)/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // 添加匹配前的内容
    if (match.index > lastIndex) {
      const id = getId();
      result.push({
        id,
        text: text.slice(lastIndex, match.index),
        type: 0,
      });
    }

    // 添加匹配的内容
    const matchedText = match[0];
    let type = 1;

    if (
      matchedText.startsWith('#') &&
      matchedText.endsWith('#') &&
      matchedText.includes('【') &&
      matchedText.includes('】')
    ) {
      type = 2;
    }

    const id = getId();
    result.push({
      id,
      text: matchedText,
      type: type,
    });

    lastIndex = regex.lastIndex;
  }

  // 添加剩余内容
  if (lastIndex < text.length) {
    const id = getId();
    result.push({
      id,
      text: text.slice(lastIndex),
      type: 0,
    });
  }
}

//检测文本是否包含指定字符超过五个
export function containsNoForbiddenCharsOrEmpty(text: string) {
  if (text === "") return true;
  const regex = /[,，！!；;。?？]|(?<!\d)\.|\.(?!\d)/g;
  const matches = text.match(regex);
  const count = matches ? matches.length : 0;
  // 如果这些符号数量小于等于5，则视为通过
  return count <= 5;
}

//防抖
export function debounce(func: any, wait: number) {
  let timeout: any;
  return function executedFunction(...args: any) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
